var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"overlay"},[_c('CSpinner',{staticClass:"spinner-loading",staticStyle:{"width":"4rem, height: 4rem"},attrs:{"color":"success","variant":"grow"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }